<template>
  <div id="content-inner-frame">
    <div class="content-top clearfix" v-if="!currentPos">当前位置：
      <span @click="goDataList">{{(notaryBusinessId == 2 || notaryBusinessId == 3) ? '贷款赋强公证' : '调解赋强公证'}}</span>-<i>"{{$router.history.current.query.name}}"</i>的证据详情</div>
    <div class="content-top clearfix" v-if="currentPos">当前位置：
      <span @click="goDataList">{{(notaryBusinessId == 2 || notaryBusinessId == 3) ? '贷款赋强公证' : '调解赋强公证'}}</span>-"
      <i @click="goDetail">{{$router.history.current.query.name}}"的证据详情-</i>
      <span style="font-size:16px;">"
        <i>{{evidenceDetailName}}"的证据详情</i></span>
    </div>
    <div class="content-main">
      <!-- <div class="search-box clearfix"> -->
        <!-- 搜索按钮 -->
        <!-- <button class="submit" @click="goSearch"></button> -->
        <!-- 搜索框 -->
        <!-- <div class="select clearfix" style="width:310px;">
          <div class="select-name">名称：</div>
          <div class="select-con" style="border:1px solid #d6d6d6;width:207px;">
            <input type="text" placeholder="请输入证据名称或者网页标题" v-model="searchName" @keyup.enter="goSearch">
          </div>
        </div>
      </div> -->
      <el-table
      border
      :data="dataList"
    >
      <template slot="empty">
        <img class="data-pic" src="../../../../../../assets/images/H5/null.png" alt>
        <br>暂无数据
      </template>
      <el-table-column prop="contractName" label="证据名称" width="140"></el-table-column>
      <el-table-column  label="网页标题" width="140">
        <template slot-scope="scope">
          <span>{{ scope.row.sourceTitle ? scope.row.sourceTitle : '-' }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="类别" width="100"> 
         <template slot-scope="scope">
          <span>{{scope.row.productName?scope.row.productName:'-'}}</span>
        </template></el-table-column> -->
        <el-table-column prop="certificateTime" label="保全时间" width="150">
      </el-table-column>
      <el-table-column prop="fileSize" label="文件大小" width="100"></el-table-column>
        <el-table-column prop="fileFormat" label="文件格式" width="100"></el-table-column>
      <el-table-column label="备注" width="150">
        <template slot-scope="scope">
          <span>{{scope.row.remark?scope.row.remark:'~'}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180">
        <template slot-scope="scope">
            <span class="see_progress" v-if="scope.row.actions.isCer"  @click="showCer(scope.$index)">查看</span> 
        </template>
      </el-table-column>
    </el-table>
      <el-pagination
        v-if="showPagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="pageSizes"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
    ></el-pagination>
    </div>
  </div>
</template>

<script>
  import BaseApi from "@lib/baseApi.js";
  import {mapState, mapGetters} from "vuex";
export default {
  name: "",
  components: {  },
  data() {
    return {
      user: {},
      currentPos: 0,
      notarizationID: -1,
      currentPid: -1,
      evidenceDetailName: "",
      evidenceDetailId: "",
      hasData: false,
      dataList: [],
      pageInfo: {
        pageNumber: 1,
        pageSize: 10
      },
      searchName: "",
      searchPage: {
        pageNumber: 1,
        pageSize: 10
      },
      source: -1,
      id: -1,
      isAsync: true,
      showPagination: false,
      currentPage: 1, //默认第一页
      total: 80, //总条数
      pageSizes: [10, 20, 50, 100, 200], //每页展示多少条
      pageSize: 10, //默认第一页展示10条
      notaryBusinessId: ''
    };
  },
  mounted() {
    this.notaryBusinessId = this.$route.query.notaryBusinessId
    this.init();
  },
  computed:{
      ...mapState(['currentInfo','userInfo','curState']),
  },
  methods: {
    init() {
      this.user = JSON.parse(sessionStorage.getItem("userInfo"));
      this.currentPos = 0;
      let query = this.$router.history.current.query;

      this.notarizationID = query.notarizationID;
      this.source = query.source;
      this.id = query.id;
      // this.searchName = query.name;

      this.dataRequest();
    },
    goDataList() {
      if(this.$route.query.flag==4){ // 强执公证
        if (this.notaryBusinessId == 3 ) {
          this.$router.push("/personal/service/loan?flag=execution");
        } else if (this.notaryBusinessId == 8) {
          this.$router.push("/personal/service/conciliation?flag=execution");
        }
      }else{
        if (this.notaryBusinessId == 2 ) {
          this.$router.push("/personal/service/loan?flag=third");
        } else if (this.notaryBusinessId == 7) {
          this.$router.push("/personal/service/conciliation?flag=third");
        }
      }
    },
    detailOver(index) {
      this.dataList[index].actions.isDetail = false;
      this.dataList[index].actions.isDetailHover = true;
    },
    detailOut(index) {
      this.dataList[index].actions.isDetail = true;
      this.dataList[index].actions.isDetailHover = false;
    },
    cerOver(index) {
      this.dataList[index].actions.isCer = false;
      this.dataList[index].actions.isCerHover = true;
    },
    cerOut(index) {
      this.dataList[index].actions.isCer = true;
      this.dataList[index].actions.isCerHover = false;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.init();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.init();
    },
    showCer(index) {
      let item = this.dataList[index];
      let id = item.temp3;
      if (item.additional == 1) {
        // 补充资料
        this.$router.push({
          path: "/personal/serviceHome/writeProcedure/lookFqCeryificate",
          query: {
            id:item.contractId,
            type:1,
            notaryBusinessId: this.notaryBusinessId
          }
        });
      } else if(item.type==2){
        //查看存证证据-Dapp-(标准版证书证据预览)
        this.$router.push({
          path: "/personal/serviceHome/writeProcedure/lookFqCeryificate",
          query: {
            id:item.contractId,
            type:1,
            notaryBusinessId: this.notaryBusinessId
          }
        });
      }else if(item.type==3){
         //查看存证证据-Dapp-(标准版证书证据预览) 通话取证
        this.$router.push({
          path: "/personal/serviceHome/writeProcedure/lookFqCeryificate",
          query: {
            id:item.contractId,
            type:3,
            notaryBusinessId: this.notaryBusinessId
          }
        });
      }else if(item.type==4){
         //查看催告证据- pdf 预览 
        this.$router.push({
          path: "/personal/serviceHome/urgeCertificateShare",
          query: {
            filePath:item.infoPath,
            notaryBusinessId: this.notaryBusinessId
          }
        });
      }else{
        //赋强saas证书证据预览
         this.$router.push({
            path: "/personal/serviceHome/fqCertificate",
            query: {
              id:item.contractId,
              fileId:item.contractFileId,
              notaryBusinessId: this.notaryBusinessId
            }
          });
      }
    },
    gotoPage(pagingRes) {
      this.searchPage.pageNumber = pagingRes.pageNumber;
      this.searchPage.pageSize = pagingRes.pageSize;
      this.goSearch();
    },
    goSearch() {
      let path = this.$router.history.current.path;
      this.$router.push({ path, query:{ ...this.$route.query,name: this.searchName}});
    },
    goDetail() {
      this.currentPos = 0;
      this.searchName = "";
      let path = this.$router.history.current.path;
     this.$router.push({ path, query:{ ...this.$route.query,name: this.searchName}});
      // this.dataRequest();
    },
    //转换文件大小
    filterType(val){
      if(val === 0)return "0 B";
      var k= 1024;
      var sizes=['B',"KB","MB","GB","TB","PB","EB","ZB","YB"],
      i= Math.floor(Math.log(val) / Math.log(k));
      return (val / Math.pow(k,i)).toPrecision(3) + " " + sizes[i];
    },
    dataRequest() {
      this.noData = false;
      this.$store.commit("showLoading", true);
      // 数据请求
      let query = this.$route.query;
        BaseApi.createRpcToken("/notaryApply/getEvidenceList",{
            evidenceName: query.name,
            pageNumber: query.pageNumber || 1,
            pageSize: query.pageSize || 10,
            notaryApplyId: this.id
            }, "GET").then(response => {
          this.$store.commit("showLoading", false);
          if (response.code == 200) {
            // 处理页码
             this.total = response.datas.totalRow;
              if (response.datas.totalRow > 10) {
                this.showPagination = true;
              } else {
                this.showPagination = false;
              }
            // 数据处理
            let resArr = response.datas.list;
            for (let i in resArr) {
              if (this.currentPos == 1) {
                //操作
                resArr[i].actions = {
                  isDetail: false,
                  isDetailHover: false,
                  isDetailCannot: false,
                  isCer: true,
                  isCerHover: false,
                  isCerCannot: false,
                  single: true
                };
              } else {
                //操作
                resArr[i].actions = {
                  isDetail: true,
                  isDetailHover: false,
                  isDetailCannot: false,
                  isCer: true,
                  isCerHover: false,
                  isCerCannot: false,
                  single: false
                };
                if (resArr[i].hasChild == 0) {
                  resArr[i].actions.isDetail = false;
                  resArr[i].actions.isDetailCannot = true;
                }
              }
              //格式化时间
              resArr[i].finishTimeFormate = this.$moment(
                resArr[i].finishTime
              ).format("YYYY-MM-DD HH:mm:ss");
              // if( resArr[i].type == 2){
                //存证
                resArr[i].fileSize=resArr[i].fileSize;
              // }else{
              //   resArr[i].fileSize=this.filterType(resArr[i].fileSize);
              // }
            }
            this.dataList = resArr;
            if (this.dataList.length == 0) {
              this.hasData = true;
            } else {
              this.hasData = false;
            }
          } else {
            this.$store.dispatch("showMsgModal", {
              autoClose: true,
              info: response.data.message
            });
          }
        });
    }
  },
  watch: {
    $route(to, from) {
      this.dataRequest();
    },
    "curState"(data){
      if(this.$route.query.flag == 4){
        this.$router.replace("/personal/serviceHome?flag=execution")
      }else{
        this.$router.replace("/personal/serviceHome?flag=third")
      }
    }
  }
};
</script>

<style lang="scss">

#content-inner-frame{
  .el-table__empty-block{
    width: 100% !important;
  }
table {
    width: 100% !important;
    th,
    td {
      vertical-align: middle;
      height: 30px;
      padding: 0;
      text-align: center;
      .cell{
        padding:0;
        text-align: center;
        color: #242C32 !important;
        font-size: 12px;
        height: 100%;

      }
    }
    td{
      .cell{
        color: #242C32 !important;
        display: flex;
    align-items: center;
    justify-content: center;
      }
    }
    thead{
      tr{
        th{
          background-color: #f9f9f9;
        }
      }
    }
    .operation_item{
      margin: 0 5px;
      cursor: pointer;
    }
  }
  box-sizing: border-box;
  .el-table__body, .el-table__footer, .el-table__header {
    table-layout: auto !important;
    border-collapse: separate;
}
.el-table {
    border-color: #DDDDDD!important;
}
.el-table__cell{
    padding: 5px 0px!important;
  }
 th.el-table__cell {
    background: #F1F1F1 !important;
}
.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf {
    border-bottom: 1px solid #DDDDDD!important;
}
.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf {
    border-color: #DDDDDD!important;
}
.el-table .cell{
  line-height: 14px !important;
}
// @import "@assets/scss/base.scss";
td {
  position: relative;
}
td img {
  cursor: pointer;
}
.noDataBox {
  width: 100%;
  height: 440px;
  border: 1px solid #d2d2d2;
  border-top: 0;
  position: relative;
}
.noDataBox img {
  display: block;
  margin: 0 auto;
  padding-top: 190px;
}
.noDataBox p {
  position: absolute;
  left: 50%;
  top: 55%;
  transform: translate(-50%, -50%);
  font-size: 14px;
  color: #999;
}
.select {
  width: 208px;
  height: 34px;
  line-height: 34px;
  float: left;
  margin-bottom: 15px;
  font-size: 12px;
  float: right;
}
.select .select-name {
  float: left;
  width: 90px;
  height: 34px;
  text-align: center;
  line-height: 34px;
  border: 1px solid #d6d6d6;
  border-right: 0;
  color: #666;
}
.select .select-con {
  width: 117px;
  height: 34px;
  float: left;
  border: 0;
  outline: 0;
  position: relative;
}
.select .select-con input {
  width: 195px;
  position: absolute;
  height: 26px;
  border: 0;
  top: 3px;
  left: 5px;
}
.submit {
  width: 38px;
  height: 34px;
  float: right;
  display: inline-block;
  border: 0;
  margin-right: 35px;
  background: #D81212 url(../../../../../../assets/images/common/search.png)
    no-repeat center;
    cursor: pointer;
}
.notarization-datalist {
  width: 100%;
  box-sizing: border-box;
  padding-left: 15px;
  padding-right: 15px;
  font-size: 14px;
  overflow: hidden;
}
/*位置*/
.content-top {
  height: 52px;
  background: url(../../../../../../assets/images/judicial/pos.png) no-repeat;
  font-size: 16px;
  background-size: 3px 16px;
  background-position: 0 24px;
  box-sizing: border-box;
  padding-left: 13px;
  padding-top: 21px;
}
.content-top span {
  cursor: pointer;
  /*color: #cc4355;*/
}
.content-top i {
  font-style: normal;
  color: #D81212;
}
/*主要区域*/
.content-main {
  border-top: 1px solid #dbdbdb;
  padding-top: 15px;
}
.progress {
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
}
.cancle {
  position: absolute;
  left: 32%;
  transform: translate(-50%, -50%);
}
.list {
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
}
.move {
  left: 50%;
}
.see_progress{
  cursor:pointer;
  color: #D81212;
}
// .see_progress:hover{
//     color: $reminder-text;
// }
}

</style>
